/**
 * Martina London — Collection PLP
 * Toolbar grid-column toggle + multi-variant quick add.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------
   * Grid toggle
   * Desktop (≥768px): 4-up ↔ 2-up
   * Mobile (<768px):  2-up ↔ 1-up
   * Persists choice per breakpoint in localStorage.
   * -------------------------------------------------------- */
  const GRID_KEY        = 'martina-london-grid-mode';
  const GRID_KEY_MOBILE = 'martina-london-grid-mode-mobile';
  const gridToggle = document.querySelector('[data-grid-toggle]');
  const grid       = document.querySelector('[data-collection-grid]');

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  if (gridToggle && grid) {
    // Restore saved state on load
    try {
      if (isMobile()) {
        if (localStorage.getItem(GRID_KEY_MOBILE) === '1') {
          grid.classList.add('is-grid-1');
          gridToggle.setAttribute('data-mobile-mode', '1');
        }
      } else {
        if (localStorage.getItem(GRID_KEY) === '2') {
          gridToggle.dataset.gridMode = '2';
          grid.classList.add('is-grid-2');
          const label = gridToggle.querySelector('.collection-toolbar__grid-label');
          if (label) label.textContent = 'Compact view';
        }
      }
    } catch (_) {}

    gridToggle.addEventListener('click', () => {
      if (isMobile()) {
        const isOneUp = grid.classList.contains('is-grid-1');
        grid.classList.toggle('is-grid-1', !isOneUp);
        if (isOneUp) {
          gridToggle.removeAttribute('data-mobile-mode');
        } else {
          gridToggle.setAttribute('data-mobile-mode', '1');
        }
        try {
          localStorage.setItem(GRID_KEY_MOBILE, isOneUp ? '2' : '1');
        } catch (_) {}
      } else {
        const newMode = gridToggle.dataset.gridMode === '4' ? '2' : '4';
        gridToggle.dataset.gridMode = newMode;
        grid.classList.toggle('is-grid-2', newMode === '2');
        const label = gridToggle.querySelector('.collection-toolbar__grid-label');
        if (label) label.textContent = newMode === '2' ? 'Compact view' : 'Grid view';
        try {
          localStorage.setItem(GRID_KEY, newMode);
        } catch (_) {}
      }
    });
  }

  /* ----------------------------------------------------------
   * Quick add — choose colour, then size, then Add to cart,
   * which drops the piece in the bag and goes straight to
   * checkout. Options are matched by NAME so option order in
   * the product doesn't matter.
   * -------------------------------------------------------- */
  async function addAndCheckout(variantId, btn) {
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (_) {
      if (btn) {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = original; }, 1500);
      }
    }
  }

  const lc = (s) => (s || '').toString().toLowerCase();

  function buildPicker(container) {
    const dataEl = container.querySelector('[data-qa-json]');
    const panel = container.querySelector('[data-qa-panel]');
    if (!dataEl || !panel) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }

    const names = data.optionNames || [];
    const variants = data.variants || [];
    const colourIdx = names.findIndex((n) => lc(n).indexOf('colour') > -1 || lc(n).indexOf('color') > -1);
    const sizeIdx = names.findIndex((n) => lc(n).indexOf('size') > -1);
    const uniq = (arr) => arr.filter((v, i) => arr.indexOf(v) === i);
    const colours = colourIdx > -1 ? uniq(variants.map((v) => v.options[colourIdx])) : [];
    const sizes = sizeIdx > -1 ? uniq(variants.map((v) => v.options[sizeIdx])) : [];
    const sizesReal = sizes.filter((s) => lc(s) !== 'one size');

    const state = { colour: colours.length === 1 ? colours[0] : null, size: null };

    const isAvailable = (colour, size) => variants.some((v) =>
      (colourIdx < 0 || v.options[colourIdx] === colour) &&
      (sizeIdx < 0 || size == null || v.options[sizeIdx] === size) &&
      v.available);

    const findVariant = () => variants.find((v) =>
      (colourIdx < 0 || v.options[colourIdx] === state.colour) &&
      (sizeIdx < 0 || sizesReal.length === 0 || v.options[sizeIdx] === state.size));

    const label = (t) => {
      const s = document.createElement('span');
      s.className = 'collection-product__qa-label';
      s.textContent = t;
      return s;
    };
    const pill = (t, selected, disabled) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'collection-product__variant' + (selected ? ' is-selected' : '');
      b.textContent = t;
      if (disabled) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      return b;
    };

    function render() {
      panel.innerHTML = '';

      if (colours.length > 1) {
        const step = document.createElement('div');
        step.className = 'collection-product__qa-step';
        step.appendChild(label('Colour'));
        colours.forEach((c) => {
          const b = pill(c, state.colour === c, !isAvailable(c, null));
          b.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); state.colour = c; state.size = null; render(); });
          step.appendChild(b);
        });
        panel.appendChild(step);
      }

      const colourReady = colourIdx < 0 || state.colour != null;

      if (colourReady && sizesReal.length > 0) {
        const step = document.createElement('div');
        step.className = 'collection-product__qa-step';
        step.appendChild(label('Size'));
        sizesReal.forEach((s) => {
          const b = pill(s, state.size === s, !isAvailable(state.colour, s));
          b.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); state.size = s; render(); });
          step.appendChild(b);
        });
        panel.appendChild(step);
      }

      const sizeReady = sizeIdx < 0 || sizesReal.length === 0 || state.size != null;

      if (colourReady && sizeReady) {
        const v = findVariant();
        const add = document.createElement('button');
        add.type = 'button';
        add.className = 'collection-product__qa-add';
        add.textContent = (v && v.available) ? 'Add to cart' : 'Sold out';
        if (!v || !v.available) add.disabled = true;
        add.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); if (v && v.available) addAndCheckout(v.id, add); });
        panel.appendChild(add);
      }
    }

    render();
    panel.hidden = false;
  }

  document.querySelectorAll('[data-qa-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const container = trigger.closest('[data-qa]');
      const single = trigger.dataset.qaSingle;
      if (single) { addAndCheckout(single, trigger); return; }
      if (!container || container.dataset.expanded === 'true') return;
      container.dataset.expanded = 'true';
      trigger.setAttribute('aria-expanded', 'true');
      trigger.hidden = true;
      buildPicker(container);
    });
  });

  // Collection card video hover — play on mouseenter, pause+reset on mouseleave
  document.querySelectorAll('[data-has-video]').forEach((card) => {
    const video = card.querySelector('[data-card-video]');
    if (!video) return;
    card.addEventListener('mouseenter', () => video.play().catch(() => {}));
    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });
  });

  // Click outside → collapse expanded pickers, restore the trigger
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-qa]')) return;
    document.querySelectorAll('[data-qa][data-expanded="true"]').forEach((container) => {
      container.dataset.expanded = 'false';
      const panel = container.querySelector('[data-qa-panel]');
      if (panel) { panel.hidden = true; panel.innerHTML = ''; }
      const trigger = container.querySelector('[data-qa-trigger]');
      if (trigger) { trigger.hidden = false; trigger.setAttribute('aria-expanded', 'false'); }
    });
  });
})();
